module.exports = __webpack_public_path__ + "static/media/15f-07_Vista-de-Instalacion-Medidas-variables.86d6ae86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15f/15f-07_Vista-de-Instalacion-Medidas-variables.jpg
// module id = 180
// module chunks = 0